import { render, staticRenderFns } from "./FireBehavior.vue?vue&type=template&id=3aa8d2ea&"
import script from "./FireBehavior.vue?vue&type=script&lang=js&"
export * from "./FireBehavior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports